"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSessionIdLogin = void 0;
const useCirrus_1 = require("../../hooks/useCirrus");
const useCirrusAccessTokenLogin_1 = require("./useCirrusAccessTokenLogin");
const useCirrusLoginCredentials_1 = require("./useCirrusLoginCredentials");
const useCirrusSessionIdStorage_1 = require("./useCirrusSessionIdStorage");
function useCirrusSessionIdLogin() {
    const { host } = useCirrus_1.useCirrus();
    const [sessionId] = useCirrusSessionIdStorage_1.useCirrusSessionIdStorage(host);
    const accessToken = useCirrusAccessTokenLogin_1.useUrlAccessToken();
    const attemptLoginWithSessionId = !accessToken;
    return useCirrusLoginCredentials_1.useCirrusLoginCredentials(sessionId && attemptLoginWithSessionId ? { sessionId } : null);
}
exports.useCirrusSessionIdLogin = useCirrusSessionIdLogin;
//# sourceMappingURL=useCirrusSessionIdLogin.js.map